import { TextDisplayCell } from "../../../common/components/DataGrid";
import { generateDeviceInfoCell } from "../../helpers/CellGenerators";

export const DeviceInfoCell = ({ row, lookupValues }) => {
  return <TextDisplayCell value={generateDeviceInfoCell(row, lookupValues)} />;
};
